import { Checkbox } from '@/components/ui/checkbox'

import { isIncomplete } from './capabilities-derive'
import { TogglePill } from './toggle-pill'
import { useCapabilitiesForm } from './use-capabilities-form'
import { YearsInput } from './years-input'

/** one leaf: a checkbox + label; when selected it reveals the years input and
 *  the two sourcing pills, with an amber outline until both are filled. */
export function CapabilityLeafRow({
  leafKey,
  label
}: {
  leafKey: string
  label: string
}) {
  const { state, dispatch } = useCapabilitiesForm()
  const row = state.rows[leafKey]

  if (!row) {
    return (
      <label className='flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-[13px] text-ink-soft hover:bg-cream/40 hover:text-ink'>
        <Checkbox
          checked={false}
          onCheckedChange={() => dispatch({ type: 'toggleLeaf', leafKey })}
        />
        <span>{label}</span>
      </label>
    )
  }

  const yearsMissing = row.yearsInBusiness === 0
  const sourcingMissing = !row.inHouse && !row.subContracted
  return (
    <div
      className={`flex flex-col gap-2 rounded-lg border px-2 py-2 ${
        isIncomplete(row)
          ? 'border-amber-400 dark:border-amber-600'
          : 'border-border'
      }`}
    >
      <label className='flex cursor-pointer items-center gap-2 text-[13px] font-medium text-ink'>
        <Checkbox
          checked
          onCheckedChange={() => dispatch({ type: 'toggleLeaf', leafKey })}
        />
        <span>{label}</span>
      </label>
      <div className='flex flex-wrap items-center gap-3 pl-0 sm:pl-6'>
        <YearsInput
          id={`${leafKey}-years`}
          value={row.yearsInBusiness}
          missing={yearsMissing}
          onChange={years => dispatch({ type: 'setYears', leafKey, years })}
        />
        <div
          role='group'
          aria-label='Sourcing'
          aria-invalid={sourcingMissing || undefined}
          className='flex w-full items-center gap-2 sm:w-auto'
        >
          <TogglePill
            className='flex-1 sm:flex-none'
            label='In-house'
            selected={row.inHouse}
            missing={sourcingMissing}
            onClick={() =>
              dispatch({ type: 'toggleSourcing', leafKey, which: 'inHouse' })
            }
          />
          <TogglePill
            className='flex-1 sm:flex-none'
            label='Sub-contracted'
            selected={row.subContracted}
            missing={sourcingMissing}
            onClick={() =>
              dispatch({
                type: 'toggleSourcing',
                leafKey,
                which: 'subContracted'
              })
            }
          />
        </div>
      </div>
    </div>
  )
}
